import { useEffect, useState } from "react";
import { useApiInfoContextValueHook } from "../../../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../../../utils/sellertool-signature-utils";
import { useReturnExchangeArchivesActionsContextHook } from "../contexts/ReturnExchangeArchivesContext";
import { ReturnExchangeArchivesApi } from "../../../../apis/ReturnExchangeArchivesApi";

export function useFetcher(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const returnExchangeArchivesActionsContextHook = useReturnExchangeArchivesActionsContextHook();

    const fetchReturnExchangeArchives = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const response = await ReturnExchangeArchivesApi().searchList({ headers: headers });
        if (response?.content) {
            returnExchangeArchivesActionsContextHook.returnExchangeArchives.onSet(response.content);
        }
    }

    return {
        fetchReturnExchangeArchives
    }
}